import { useMemo } from 'react'
import useTrans from '../../../hooks/useTrans'
import { Button } from '../../atoms'
import NewModal from '../../molecules/NewModal/NewModal'

const QuantitaInsufficienteModal = ({
  isVisible,
  setVisible,
  quantita_minima_personalizzabile,
}) => {
  const t = useTrans()
  return (
    <NewModal
      visible={isVisible}
      alert={true}
      title={t('La quantità inserita non è sufficiente per la personalizzazione')}
      text={t(
        'Ti invitiamo ad aggiornare il numero degli articoli da personalizzare in modo da poter soddisfare \
          la quantità minima personalizzabile\
        '
      )}
      actions={[
        <Button
          label={t('Modifica quantità')}
          variant="primary"
          size="medium"
          onClick={() => setVisible(false)}
        />,
      ]}
    >
      <div className="quantita-insufficiente-modal">
        <span className="quantita-insufficiente-modal__label">
          {t('Quantità minima personalizzabile:')}
        </span>{' '}
        <span className="quantita-insufficiente-modal__value">
          {quantita_minima_personalizzabile}
        </span>
      </div>
    </NewModal>
  )
}

export default QuantitaInsufficienteModal
